import type { FC } from "react";
import type { SegmentsModalProps } from "app/components/React/TableSelectionComponents/segment-selection/segments-modal/types";
import { STEPS_COMPONENTS } from "app/components/React/TableSelectionComponents/segment-selection/segments-modal/stepsComponents";

export const SegmentModal: FC<SegmentsModalProps> = (props) => {
    const { step } = props;
    const Component = STEPS_COMPONENTS[step];
    return <Component {...props} />;
};
